
export default {
  computed: {
    breadcrumbs() {
      return this.$store.getters["general/getBreadcrumbs"];
    },
    domain() {
      return process.env.DOMAIN || "";
    },
  },
};
